/**
 * AlarmService
 * --------------------------------------------
 * --------------------------------------------
 *
 * Controlador que tiene los endpoints de Alarmas.
 *
 * Endpoints:
 * ------------------
 * 1.  GET    ->  {ENDPOINT_PATH}{idCluster}/alarms
 * 2.  POST    ->  {ENDPOINT_PATH}{idCluster}/solarhubs/{idSolarHub}/alarms
 * 3.  DELETE    ->  {ENDPOINT_PATH}{idCluster}/solarhubs/{idSolarHub}/alarms/{idAlarm}
 *
 */
import axios from "axios";

import { getAuthToken } from "@/utils/AuthService.js";

const ENDPOINT_PATH = " http://urbanbrain.siarq.com:8080/cluster/";

/** 1. Endpoint getAlarms
 * ------------------------------------------------------------------------------
 * Obtiene todas las alarmas de un cluster.
 *
 * url: {ENDPOINT_PATH}{idCluster}/alarms
 *
 * method: GET
 *
 * type: JSON
 *
 * @param {String} idCluster
 */
export function getAlarms(idCluster) {
  return new Promise(async (resolve, reject) => {
    try {
      let alarms = await axios({
        url: `${ENDPOINT_PATH}${idCluster}/alarms`,
        method: "GET",
        headers: { Authorization: `Bearer ${getAuthToken()}` },
      });
      resolve(alarms.data);
    } catch (err) {
      console.error("Caught an error during report:", err);
      reject(err);
    }
  });
}

/** 2. Endpoint de addAlarm
 * ------------------------------------------------------------------------------
 * Crea una nueva alarma
 *
 * url: {ENDPOINT_PATH}login
 *
 * method: POST
 *
 * type: JSON
 *
 * @param alarm
 * @param idCluster
 * @param idSolarHub
 */
export function addAlarm(alarm, idCluster, idSolarHub) {
  return new Promise(async (resolve, reject) => {
    try {
      let res = await axios({
        url: `${ENDPOINT_PATH}${idCluster}/solarhubs/${idSolarHub}/alarms`,
        method: "POST",
        headers: { Authorization: `Bearer ${getAuthToken()}` },
        data: {
          channel: alarm.notification,
          creationDate: new Date().toLocaleDateString('es-ES'),
          sensor: alarm.sensor,
        },
      });
      resolve(res.data);
    } catch (err) {
      console.error("Caught an error during login:", err);
      reject(err);
    }
  });
}

/** 3. Endpoint de deleteAlarm
 * ------------------------------------------------------------------------------
 * Elimina la alarma del solarhub del cluster
 *
 * url: {ENDPOINT_PATH}login
 *
 * method: DELETE
 *
 * @param idCluster
 * @param idSolarHub
 * @param idAlarm
 *
 */
export function deleteAlarm(idCluster, idSolarHub, idAlarm) {
  return new Promise(async (resolve, reject) => {
    try {
      let alarm = await axios({
        url: `${ENDPOINT_PATH}${idCluster}/solarhubs/${idSolarHub}/alarms/${idAlarm}`,
        method: "DELETE",
        headers: { Authorization: `Bearer ${getAuthToken()}` },
      });
      resolve(alarm.data);
    } catch (err) {
      console.error("Caught an error during report:", err);
      reject(err);
    }
  });
}
